import React, { useEffect, useState } from "react";
import styles from './index.module.css';
import { useDispatch, useSelector } from "react-redux";
import { getAllActiveBanners } from "../../redux/features/banner/bannerServices";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";

const Banner = () => {
    const dispatch = useDispatch();
    const { isBannersLoading, isBannersSuccess, banners } = useSelector((state) => state.banner.allActiveBanners);

    const [index, setIndex] = useState(0);
    const [isTransitioning, setIsTransitioning] = useState(true);

    useEffect(() => {
        dispatch(getAllActiveBanners());
    }, [dispatch]);

    const [isMobileView, setIsMobileView] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            setIsMobileView(window.innerWidth < 744);
        };
        handleResize();
        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if (banners.length > 0) {
            const interval = setInterval(() => {
                if (index === banners.length) {
                    setTimeout(() => {
                        setIsTransitioning(false);
                        setIndex(0);
                    }, 500);
                } else {
                    setIsTransitioning(true);
                    setIndex((prevIndex) => prevIndex + 1);
                }
            }, 3000);
            return () => clearInterval(interval);
        }
    }, [index, banners]);

    if (isBannersLoading) {
        return (
            <div className={styles.bannerContainer}>
                <div className={styles.slider}>
                    <SkeletonTheme baseColor="#EDEDED" highlightColor="#ffffff">
                        <Skeleton
                            height={isMobileView ? 400 : 350}
                            className={styles.bannerSkeleton}
                        />
                    </SkeletonTheme>
                </div>
            </div>
        );
    }

    return (
        <>
            <div className={styles.bannerContainer}>
                {!isBannersLoading && banners.length > 0 && (
                    <div className={styles.slider}>
                        <div
                            className={`${styles.slides} ${isTransitioning ? styles.transition : ""}`}
                            style={{ transform: `translateX(-${index * 100}%)` }}
                        >
                            {banners.map((banner, i) => (
                                <img key={i} src={isMobileView ? banner.image_url_for_mobile : banner.image_url} alt={`Slide ${i + 1}`} className={styles.slide} />
                            ))}
                            <img src={isMobileView? banners[0].image_url_for_mobile : banners[0].image_url} alt="Clone Slide" className={styles.slide} />
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default Banner;